import { useConnection, useHealth, useNow, useReloadOffered } from "../../client/index.ts";
import { designCopy } from "../../design/copy.ts";
import { formatTime, saoPaulo } from "../../design/format/dates.ts";
import { healthText } from "../../design/format/status.ts";
import { Banner } from "../../design/primitives/Banner.tsx";
import { Button } from "../../design/primitives/Button.tsx";
import { shellCopy } from "../copy.ts";
import styles from "./Banners.module.css";

export function Banners() {
  const { connection, offline } = useConnection();
  const reload = useReloadOffered();
  const schedule = healthText(useHealth(), useNow());
  const stopped = schedule?.tone === "negativo" || schedule?.round ? schedule : undefined;
  if (!(offline && connection.state === "caida") && !reload && stopped === undefined) return null;
  return (
    <div className={styles.banners}>
      {stopped === undefined ? null : (
        <Banner tone={stopped.tone} action={<Button href="/contas">{designCopy.lugares.contas}</Button>}>
          {stopped.text}
        </Banner>
      )}
      {offline && connection.state === "caida" ? <Banner tone="atencao">{shellCopy.conexao.offline(formatTime(new Date(connection.since).toISOString(), saoPaulo))}</Banner> : null}
      {reload ? (
        <Banner tone="outros" action={<Button onClick={() => location.reload()}>{shellCopy.conexao.recarregar}</Button>}>
          {shellCopy.conexao.versaoNova}
        </Banner>
      ) : null}
    </div>
  );
}
